import { css } from '@emotion/react'
import { eerieBlack } from '../../style/colors'

export const typographyTitleStyle = css`
  font-size: 14px;
  line-height: 16px;
  color: ${eerieBlack['800']};
`
